
  export default {
'selectTriggerBtn' : { 

 typeTheme :{ 
 'amountSelect' : { 
  'position' : 'absolute'
 
}} 
}
,
'footerContainer' : { 
  commonTheme : {
  'padding' : '36px 21px'
  }}
,
'supportReplyInput' : { 
  commonTheme : {
  'width' : '84%'
  }}
,
'headerContainer' : { 
  commonTheme : {
  'padding' : '0 72px'
  }}
,
'button' : { 

 typeTheme :{ 
 'reStore' : { 
  'width' : '551px'
 
},
 'returnGame' : { 
  'width' : '551px'
 
}} 
}

}